export default __webpack_public_path__ + "static/media/GameOn.6688efc4c924169921c7169cfbc51cd1.webp";